import type {
  DataExportResponse,
  EmailChangeRequest,
  EmailChangeResponse,
  EmailStatus,
  SignInMethodsResponse,
  SocialSignInInput,
} from "@atlas/shared";
import { apiDelete, apiGet, apiPost } from "../lib/api-client";

// "Download my data" (spec 17). Query key ["account/export"]; the panel polls
// while an export is pending/processing.

export function fetchDataExport(): Promise<DataExportResponse> {
  return apiGet<DataExportResponse>("/account/export");
}

export function requestDataExport(): Promise<DataExportResponse> {
  return apiPost<DataExportResponse>("/account/export");
}

// ─── Add / change email ───────────────────────────────────────────────────────
// Query key ["account/email"]; the EmailCaptureCard polls it while a
// confirmation link is outstanding and refreshes ["me"] once verified.

export const EMAIL_STATUS_QUERY_KEY = ["account/email"] as const;

export function fetchEmailStatus(): Promise<EmailStatus> {
  return apiGet<EmailStatus>("/account/email");
}

export function requestEmailChange(data: EmailChangeRequest): Promise<EmailChangeResponse> {
  return apiPost<EmailChangeResponse>("/account/email", data);
}

// ─── Sign-in methods (ATL-130) ───────────────────────────────────────────────
// Query key ["account/sign-in-methods"]. Link posts the same credential the
// login page sends; unlink is refused by the server when it would leave no
// way to sign in.

export const SIGN_IN_METHODS_QUERY_KEY = ["account/sign-in-methods"] as const;

export function fetchSignInMethods(): Promise<SignInMethodsResponse> {
  return apiGet<SignInMethodsResponse>("/account/sign-in-methods");
}

export function linkSignInMethod(
  input: Pick<SocialSignInInput, "provider" | "idToken" | "authorizationCode" | "nonce">,
): Promise<SignInMethodsResponse> {
  const { provider, ...body } = input;
  return apiPost<SignInMethodsResponse>(`/account/sign-in-methods/${provider}`, body);
}

export function unlinkSignInMethod(provider: "apple" | "google"): Promise<SignInMethodsResponse> {
  return apiDelete<SignInMethodsResponse>(`/account/sign-in-methods/${provider}`);
}
